import { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import { useFormik } from "formik";
import Yup from "validation/Validation";
import { Pane, Spinner } from "evergreen-ui";
import { useParams } from "react-router-dom";
import { BreadcrumbsWidget } from "components";
import ArticleTitle from "./ArticleTitle";
import DetailForm from "./DetailForm";
import {
  useGetCategoriesQuery,
  useInsertArticleMutation,
  useSingleArticleMutation,
  useUpdateArticleMutation,
} from "redux/api/slices/server";

const DetailArticlePage = () => {
  const { id } = useParams();
  const initObject = { title: "" };
  const [content, setContent] = useState("");
  const [initialValues, setInitialValues] = useState(initObject);
  const categories = useGetCategoriesQuery();
  const [insertArticle, insertData] = useInsertArticleMutation();
  const [singleArticle, singleData] = useSingleArticleMutation();
  const [updateArticle, updateData] = useUpdateArticleMutation();
  const [urunKategori, setUrunKategori] = useState(0);
  const [youtube, setYoutube] = useState(false);
  const [images, setImages] = useState([]);
  const [newImageId, setnewImageId] = useState(-100);
  const [imagesState, setImagesState] = useState([]);
  const [token, setToken] = useState("");

  const handleOnChange = (e) => {
    setUrunKategori(e.target.value);
  };

  const handleChangeEditor = (value) => {
    setContent(value);
  };

  function extractIframeInfo(iframeCode) {
    let startIndex = iframeCode.indexOf('width="') + 7;
    let widthEndIndex = iframeCode.indexOf('"', startIndex);
    let width = iframeCode.substring(startIndex, widthEndIndex);
    startIndex = iframeCode.indexOf('height="') + 8;
    let heightEndIndex = iframeCode.indexOf('"', startIndex);
    let height = iframeCode.substring(startIndex, heightEndIndex);
    startIndex = iframeCode.indexOf('src="') + 5;
    let endIndex = iframeCode.indexOf('"', startIndex);
    let srcLink = iframeCode.substring(startIndex, endIndex);
    let videoId = srcLink.split("/").pop();
    let newYouTubeLink = "https://www.youtube.com/watch?v=" + videoId;
    let result = {
      width: width,
      height: height,
      youtubeLink: newYouTubeLink,
    };
    return result;
  }

  const onChangeImages = (imageList, addUpdateIndex) => {
    let currentNewImageId = newImageId;
    imageList.forEach((element) => {
      if (isNaN(element.id) || element.id === 0) {
        element.id = currentNewImageId;
        element.deleted = false;
        currentNewImageId--;
      }
    });
    setnewImageId(currentNewImageId);
    setImages(imageList);

    let tmpImageState = imagesState;
    //YENI EKLENEN RESIMLERI imagesState'E EKLE
    const newImageList = imageList.filter(
      (newImage) => !imagesState.some((image) => image.id === newImage.id)
    );
    tmpImageState = [...tmpImageState, ...newImageList];
    //SILINEN RESIMLERI imagesState'DE deleted olarak isaretle
    tmpImageState.forEach((imgState) => {
      let bulundu = false;
      imageList.forEach((img) => {
        if (img.id === imgState.id) bulundu = true;
      });
      if (!bulundu) {
        //Arrayden cikarma! Varolan resimler arrayden cikarsa sunucuda sildigini nasil bilecek?
        imgState.deleted = true;
        imgState.data_url = "";
      }
    });
    setImagesState(tmpImageState);
  };

  function generateToken(length = 32) {
    const characters =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let token = "";
    for (let i = 0; i < length; i++) {
      token += characters[Math.floor(Math.random() * characters.length)];
    }
    return token;
  }

  const formFields = { title: Yup.string().required() };
  const validationSchema = Yup.object(formFields);
  const formikConfig = {
    initialValues: initialValues,
    validationSchema: validationSchema,
    validateOnChange: false,
    enableReinitialize: true,
    onSubmit: (values) => {
      resetForm();
      const sendObject = {
        title: values.title,
        content: content,
        categoryId: parseInt(urunKategori),
        video: youtube,
        id: id,
      };

      if (parseInt(id) > 0) {
        updateArticle(sendObject);
        setInitialValues({ title: values.title });
      } else {
        setContent("");
        setYoutube(false);
        setUrunKategori(0);
        insertArticle(sendObject);
      }
    },
  };

  const { handleSubmit, handleChange, values, errors, resetForm } =
    useFormik(formikConfig);

  useEffect(() => {
    setToken(generateToken());
  }, []);

  useEffect(() => {
    singleArticle({ id });
  }, [id, singleArticle]);

  useEffect(() => {
    if (id > 0) {
      if (singleData.isSuccess) {
        setUrunKategori(singleData.data.categoryId);
        setContent(singleData.data.content);
        setInitialValues({ title: singleData.data.title });

        if (singleData.data.video) {
          const videoObjec = extractIframeInfo(singleData.data.video.video);
          setYoutube(videoObjec);
        }

        if (singleData.data.token) {
          setToken(singleData.data.token);
        }

        if (singleData.data.uploadedImage) {
          setImages(singleData.data.uploadedImage);
          const imagesStateArray = singleData.data.uploadedImage.map(
            (row, i) => {
              return {
                id: row.id,
                data_url: "",
                deleted: false,
              };
            }
          );

          setImagesState(imagesStateArray);
        }
      }
    }
  }, [id, singleData]);

  if (insertData.isLoading || singleData.isLoading || updateData.isLoading) {
    return (
      <div className="w-full flex justify-center items-center">
        <Pane>
          <Spinner marginX="auto" size={60} marginTop={25} marginBottom={50} />
          <Typography variant="h5" gutterBottom>
            İşlem Yapılıyor. Lütfen Bekleyniz...
          </Typography>
        </Pane>
      </div>
    );
  }

  return (
    <div className="w-full my-6">
      <div className="w-full h-auto container mx-auto">
        <div className="w-full mb-6">
          <BreadcrumbsWidget
            data={[{ title: "Makaleler", url: "/articles" }]}
            activeItem={id > 0 ? "Makale Düzenle" : "Makale Ekle"}
          />
        </div>
        <div className="w-full h-auto flex flex-col p-5 gap-4 border shadow bg-white">
          <ArticleTitle
            initialValues={initialValues}
            id={id}
            insertData={insertData}
            updateData={updateData}
          />
          <DetailForm
            id={parseInt(id)}
            handleSubmit={handleSubmit}
            handleChange={handleChange}
            initialValues={initialValues}
            values={values}
            categories={categories}
            errors={errors}
            urunKategori={urunKategori}
            handleOnChange={handleOnChange}
            content={content}
            handleChangeEditor={handleChangeEditor}
            youtube={youtube}
            setYoutube={setYoutube}
            images={images}
            onChangeImages={onChangeImages}
            imagesState={imagesState}
            setImagesState={setImagesState}
            setImages={setImages}
            token={token}
            setToken={setToken}
          />
        </div>
      </div>
    </div>
  );
};

export default DetailArticlePage;
